import type { RouteObject } from "react-router";

/** /cart is public: guests have a cart too (kept in the browser, priced by the server). */
export const cartRoutes: RouteObject[] = [
  {
    path: "cart",
    handle: { shell: { tab: "cart", canvas: true } },
    lazy: async () => ({ Component: (await import("./ui/CartPage")).CartPage }),
  },
];
